import React, { useContext } from "react";
import {
  Caption,
  Card,
  Collapsible,
  ColorPicker,
  Layout,
  Stack,
  TextField,
  TextStyle,
  TextContainer,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ToastBackground = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, TOAST_BACKGROUND_COLOR, DEFAULT_TOAST_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.toastBackgroundColor.title")}
        description={cms("section.toastBackgroundColor.description")}
      >
        <Card
          title={[
            cms("section.toastBackgroundColor.title"),

            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
        >
          <Card.Section>
            <TextContainer>{cms("section.toastBackgroundColor.subDescription")}</TextContainer>

            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.toastBackgroundColor.label.hexCode")}
                  value={hex.toastBackgroundHex}
                  onChange={(value) => handleChange(TOAST_BACKGROUND_COLOR, value, HEX)}
                  labelAction={
                    hex.toastBackgroundHex !== DEFAULT_TOAST_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(TOAST_BACKGROUND_COLOR, DEFAULT_TOAST_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.toastBackgroundColor}
                />
                <br />
                <TextStyle>
                  <div
                    style={{
                      width: "120px",
                      height: "50px",
                      background: hex.toastBackgroundHex,
                      color: hex.toastTextHex,
                      textAlign: "center",
                      paddingTop: "13px",
                    }}
                  >
                    {cms("section.toastBackgroundColor.label.sampleHeader")}
                  </div>
                </TextStyle>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker
                  onChange={(value) => handleChange(TOAST_BACKGROUND_COLOR, value, COLOR)}
                  color={color.toastBackgroundColor}
                />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(ToastBackground);
